import { Component, effect, inject, signal, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgScrollbar } from 'ngx-scrollbar';
import { BucketService, FileNode, FolderNode } from 'src/app/services/bucket/bucket.service';
import { BucketStoreService } from '../../bucket-store.service';

@Component({
  selector: 'app-lista-file-bucket',
  standalone: false,

  templateUrl: './lista-file-bucket.component.html',
  styleUrl: './lista-file-bucket.component.scss',
})
export class ListaFileBucketComponent {
  @ViewChild('scrollbarListaFile') scrollbarListaFile!: NgScrollbar;

  private readonly _store = inject(BucketStoreService);

  get folderFiles(): FileNode[] {
    return this.getFilterFile();
  }

  get folderSelezionato() {
    return this._store.selectedFolder();
  }
  get listaFolders() {
    return this._store.tree();
  }

  get idUtente() {
    return this._store.tree()[0].id;
  }
  get idAzienda() {
    return this._store.tree()[0].folders[0].id;
  }

  folderSelectedEffect = effect(() => {
    const folderSelected = this._store.selectedFolder();
    if (folderSelected) {
      this._updateScrollbar();
    }
  });

  constructor(
    public dialog: MatDialog,
    private readonly _bucketService: BucketService,
    private readonly _dialog: MatDialog,
  ) {
    this._store.updateScrollbar$.subscribe((esito) => {
      this._updateScrollbar();
    });
  }

  onFolderDblClick(folder: FolderNode) {
    this._store.setSelectedFolder(folder);
  }

  hasSottoCartelle = (folder: FolderNode) => !!folder.folders.length;

  hasFile = (folder: FolderNode) => !!folder.files.length;

  private _updateScrollbar() {
    setTimeout(() => {
      this.scrollbarListaFile?.update();
    }, 0);
  }

  showFiltri = true;
  isSearchBarOpen(isOpen: boolean) {
    this.showFiltri = !isOpen;
  }

  getFilterFile() {
    const folder = this._store.selectedFolder();
    const filterEstensione = this._store.tipoFilter();
    const filterUtente = this._store.utenteFilters();
    const sortFilesBy = this._store.sortFilesBy();

    if (!folder) return [];

    // Filtri
    let files = folder.files.filter((file) => {
      const matchesEstensione =
        !filterEstensione?.length ||
        (file.extension ? filterEstensione.includes(file.extension.toUpperCase()) : false);
      const matchesUtente =
        !filterUtente?.length ||
        (file.idUtenteCreazione ? filterUtente.includes(file.idUtenteCreazione) : false);
      return matchesEstensione && matchesUtente;
    });

    // Ordinamento
    if (sortFilesBy?.type === 'size') {
      files = [...files].sort((a, b) =>
        sortFilesBy.order === 'crescente'
          ? (a.size || 0) - (b.size || 0)
          : (b.size || 0) - (a.size || 0),
      );
    }

    if (sortFilesBy?.type === 'data') {
      files = [...files].sort((a, b) =>
        sortFilesBy.order === 'crescente'
          ? new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          : new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
    }

    return files;
  }

  async onFileDropped(files: File[]) {
    await this._store.importaFile(files);
    this._store.updateScrollbar();
  }

  isDragging = signal<boolean>(false);

  // 1. Chiamato dal tuo evento di drag
  onDraggingStateChange(isDragging: boolean) {
    this.isDragging.set(isDragging);
  }

  /**
   * Controllo se il folder selezionato È valido ma vuoto
   * @returns
   */
  isFolderValidWithoutFile() {
    const isEmpty = this.folderFiles.length === 0;
    const isSelected = !!this.folderSelezionato;
    const isNotLocked = this.folderSelezionato?.locked === false;

    // Il messaggio appare solo se tutte le condizioni sono vere
    return isEmpty && isSelected && isNotLocked;
  }

  /**
   * Controllo se la cartella selezionata è bloccata e non contiene sottocartelle
   * @returns boolean
   */
  isFolderLockedAndEmpty(): boolean {
    const isSelected = !!this.folderSelezionato;
    const isLocked = this.folderSelezionato?.locked === true;
    // Controllo che l'array delle sottocartelle sia vuoto (se esiste)
    const hasNoSubfolders = this.folderSelezionato?.folders?.length === 0;

    return isSelected && isLocked && hasNoSubfolders;
  }
}
